export const isOrderStateValid = (response) => {
    if (response.data === undefined) {
        return false;
    }

    if (response.data.identifier === undefined) {
        return false;
    }

    if (response.data.status === undefined) {
        return false;
    }

    if (response.data.timestamp === undefined) {
        return false;
    }

    return true;
};

export const isProgressStateValid = (response) => {
    if (response.data === undefined) {
        return false;
    }

    if (response.data.progress === undefined) {
        return false;
    }

    if (response.data.line === undefined) {
        return false;
    }

    if (response.data.type === undefined) {
        return false;
    }

    if (response.data.taskName === undefined) {
        return false;
    }

    if (response.data.totalLines === undefined) {
        return false;
    }

    return true;
};

export const isLastDispensedFormulasUpdatedValid = (response) => {
    if (response.data === undefined) {
        return false;
    }

    return true;
};

export const isFileTransferCustomerValid = (response) => {
    if (
        response.data === undefined ||
        response.data === null ||
        response.data.kind === undefined ||
        response.data.kind === null ||
        response.data.change === undefined ||
        response.data.change === null ||
        response.data.notification === undefined ||
        response.data.data === undefined ||
        response.data.data === null
    ) {
        return false;
    }

    return response.data.data.id !== undefined && response.data.data.name !== undefined;
};

export const isFileTransferCustomFormulaValid = (response) => {
    if (
        response.data === undefined ||
        response.data === null ||
        response.data.kind === undefined ||
        response.data.kind === null ||
        response.data.change === undefined ||
        response.data.change === null ||
        response.data.notification === undefined ||
        response.data.data === undefined ||
        response.data.data === null
    ) {
        return false;
    }

    return (
        response.data.data.productName &&
        response.data.data.colorInFandeck &&
        response.data.data.colorInFandeck.fandeck &&
        response.data.data.colorInFandeck.color
    );
};

export const isFileTransferHistoryValid = (response) => {
    if (
        response.data === undefined ||
        response.data === null ||
        response.data.kind === undefined ||
        response.data.kind === null ||
        response.data.change === undefined ||
        response.data.change === null ||
        response.data.notification === undefined ||
        response.data.data === undefined ||
        response.data.data === null
    ) {
        return false;
    }

    return response.data.data.id && response.data.data.color_name;
};

export const isFileTransferOrderValid = (response) => {
    if (
        response.data === undefined ||
        response.data === null ||
        response.data.kind === undefined ||
        response.data.kind === null ||
        response.data.change === undefined ||
        response.data.change === null ||
        response.data.notification === undefined ||
        response.data.data === undefined ||
        response.data.data === null
    ) {
        return false;
    }

    return response.data.data.id !== undefined && response.data.data.colorDisplayName !== undefined;
};
